<template>
  <div class="content">
    <h1 class="is-bold has-text-centered">iRidium BYOD {{this.$store.state.pkg.Version}}</h1>
    <h3 class="is-bold has-text-centered">{{$t('index.reg_center')}}</h3>
    <br>
    <section v-if="!$auth.check()" class="section has-text-centered">
      <router-link to="/login" class="btn">
        <button class="button is-info is-large">{{$t('index.login')}}</button>
      </router-link>
    </section>
    <section v-if="$auth.check()" class="section has-text-centered">
      <a href="/#/administration_manager" class="button is-large">{{$t('index.go_to_object_adm')}}</a>
      <a href="/#/reception_manager" class="button is-large">{{$t('index.go_to_reception_adm')}}</a>
    </section>
    <section class="section" v-if="$auth.check()">
      <div class="columns is-mobile">
        <div class="column is-full-mobile is-half-desktop is-offset-one-quarter-desktop ">

          <h2 class="is-bold has-text-centered">{{$t('index.profile.user_info')}}</h2>

          <b-field :label="$t('index.profile.login')"
              v-bind:type="{'is-danger': !data.login }"
              :message="{ [$t('index.profile.errors.fill_this_field')]: !data.login }">
              <b-input type="text" disabled
                  v-model="data.login">
              </b-input>
          </b-field>

          <b-field :label="$t('index.profile.name')"
              v-bind:type="{'is-danger': !data.name }"
              :message="{ [$t('index.profile.errors.fill_this_field')]: !data.name }">
              <b-input type="text"
                  v-model="data.name">
              </b-input>
          </b-field>

          <b-field :label="$t('index.profile.lastname')"
              v-bind:type="{'is-danger': !data.lastname }"
              :message="{ [$t('index.profile.errors.fill_this_field')]: !data.lastname }">
              <b-input type="text"
                  v-model="data.lastname">
              </b-input>
          </b-field>

          <a  @click="saveData" class="button is-large">{{$t('index.profile.save_profile')}}</a>
          <a  @click="changePass" class="button is-large">{{$t('index.profile.change_password')}}</a>


        </div>
      </div>



      <b-modal :active.sync="isChangePassword" has-modal-card>
        <changepassword></changepassword>
      </b-modal>
    </section>


  </div>
</template>

<script>
import Changepassword from './mini_components/Changepassword.vue';
import Vue from 'vue';
import Notification from 'vue-bulma-notification';
const NotificationComponent = Vue.extend(Notification);
const openNotification = (
  propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }
) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  });
};

export default {
  components: {
    Changepassword
  },

	data() {
		// return this.$store.state.pkg
    return {
      changed:false,
      data: {
        name:"",
        lastname:"",
        login:"",
        options:{
          rst_tkns_chgpswrd:0
        }
      },
      param: {},
      isloading: false,
      isChangePassword: false,
    }
	},
  mounted () {

    if (this.$auth.check()) {

      console.log("TEST")
      console.log(this.$auth)
      this.loadData()
    }

  },
	methods: {
    openNotificationWithType(type, title, message) {
      openNotification({
        title: title,
        message: message,
        type: type
      });
    },
		logout() {
			this.$auth.logout({
				redirect: 'Home',
				makeRequest: false
			})
		},
    loadData () {
      this.isloading = true
      // this.data.length = 0
      this.$http({
        url: `https://iridi.com/customer/api_byod/?act=profile&type=load`,
        transformResponse: [(data) => {
          return JSON.parse(data)
        }],
        params: {
          parameters: {
            param1: 1
          }
        }
      }).then((response) => {
        this.data = response.data
        this.isloading = false
        this.changed = false
      }).catch((error) => {
        console.log(error)
        this.isloading = false;
        this.changed = false;
      })
    },
    saveData () {

      this.isloading = true
      // this.data.length = 0
      this.$http({
        method: 'post',
        url:`https://iridi.com/customer/api_byod/?act=save_profile`,
        data:this.data
      }).then((response) => {
        this.changed = false;
        this.data = response.data
        this.isloading = false
        this.openNotificationWithType('success', '', this.$t('index.profile.profile_saved_success'))
      }).catch((error) => {
        console.log(error)
        this.isloading = false
        this.changed = false;
      })
    },
    changePass() {
      this.isChangePassword = true
    }

	}
}
</script>

<style>
.tab-content {
  margin: 10px 0px !important;
}
tr.blend {
  opacity: 0.3;
}

.tab-list a {
  font-size: 1.1rem;
}
.pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
.collapseback {
  height: calc(100vh - 168px);
  overflow: hidden;
  box-sizing: border-box;
}
.customStyleModal {
  padding: 20px;
  .modal-background {
    background-color: #f5f5f5;
  }

  .modal-content {
    overflow: auto;
  }
}
.styles-box .notification {
  margin-bottom: 20px;
  line-height: 1.25;
}

.blended {
  opacity: 0.3;
}

.wrap_table {
  overflow-x: auto;

  table {
    min-width: 480px;

    td:first-child {
      text-align: left;
    }

    th:first-child {
      text-align: left;
    }
  }

  .table td,
  .table th {
    vertical-align: middle;
    text-align: center;
  }
  .table th {
    font-weight: 500;
  }
}

@media print {
  aside {
    display: none;
  }

  .app-navbar {
    display: none;
  }

  .app-main {
    margin: 0 !important;
    padding: 0;
  }

  .modal-content,
  .modal-card {
    max-height: 100vh;
  }

  .button {
    display: none;
  }
}

.table-btn {
  margin-bottom: 3px;
}
.qrapps img {
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .customStyleModal {
    .modal-content {
      margin: 0 auto;
      max-height: calc(100vh - 140px);
      width: 95%;
    }
  }
}

@media screen and (min-width: 768px) {
  .customStyleModal {
    .modal-content {
      margin: 0 auto;
      max-height: calc(100vh - 140px);
      width: 640px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?aeda14b8